import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import SwbSettleProofDetail from './SettleProofDetail';
import SwbPurchReceiptGoodsItemList from './PurchReceiptGoodsItemList';
import SwbSettlePaymentInfo from './SettlePaymentInfo';
import SwbPayPreInfo from './PayPreInfo';
import SwbPayVoucherSave from './PayVoucherSave';
import SwbBankAccInfo from './BankAccInfo';
Vue.regist(SwbSettleProofDetail);

import settleApi from '../../api/settle';
// 加载结算业务源中利润中心选择列表
export function loadSettleBizSrcPrftCenterCodeList(proofId, callback) {
    getSettleBizSrcPrftCenterCodeList(proofId, callback);
}

function getSettleBizSrcPrftCenterCodeList(proofId, callback) {
    settleApi.getSettleBizSrcPrftCenterCodeList(proofId, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            //
            let prftCenterCodeList = result.data || [];
            if(!Utils.isNoB(prftCenterCodeList) && prftCenterCodeList.length > 0) {
                prftCenterCodeList.forEach(function (prftCenterCode) {
                    dataList.push({
                        value: prftCenterCode,
                        label: prftCenterCode
                    });
                });
            }
            callback(dataList);
        }
    });
}

export function selectPrftCenterCodeList(proofId, callback) {
    Vue.$showDialog({
        title: '选择利润中心',
        showCloseBtn: true,
        width: 400,
        height: 300,
        template: '<div class="simple-form">' +
        '<div class="form-group center">' +
        '<div class="form-label">' +
        '<label class="required">利润中心</label>' +
        '</div>' +
        '<div class="form-value flex">' +
        '<el-select v-model="prftCenterCode" placeholder="请选择">' +
        '<el-option v-for="item in prftCenterCodeList" :label="item.label" :value="item.value"></el-option>' +
        '</el-select>' +
        '</div>' +
        '</div>' +
        '</div>',
        data: {
            prftCenterCode: null,
            prftCenterCodeList: []
        },
        methods: {
            getPrftCenterCodeList: function () {
                let currSelf = this;
                getSettleBizSrcPrftCenterCodeList(proofId, function (prftCenterCodeList) {
                    currSelf.prftCenterCodeList = prftCenterCodeList || [];
                    currSelf.prftCenterCode = Utils.isTrue(currSelf.prftCenterCodeList.length > 0) ? currSelf.prftCenterCodeList[0].value : null;
                });
            }
        },
        okClicked: function () {
            if(Utils.isNoB(this.prftCenterCode)) {
                MsgBox.warning("请选择利润中心！");
                return;
            } else {
                callback(this.prftCenterCode);
            }
        },
        lifecycle: {
            created: function () {
                this.getPrftCenterCodeList();
            }
        }
    });
}

// 结算单信息查看
export function openSettleProofDetailDlg(params, title) {
    let proofId = params['id'] || null;
    let parentSelf = params['parentSelf'] || this;
    //
    let theDlg = Vue.$showDialog({
        title: title,
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-settle-proof-detail :proofId="proofId" :parentSelf="parentSelf"></swb-settle-proof-detail>' +
        '</div>',
        data: {
            proofId: proofId,
            parentSelf: parentSelf
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbPurchReceiptGoodsItemList);
// 验收商品项查看
export function openPurchReceiptGoodsItemListDlg(params) {
    //
    let receiptId = params["receiptId"];
    //
    let theDlg = Vue.$showDialog({
        title: "结算明细 - 查看",
        width: -100,
        height: 850,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<div class = "">' +
        '<swb-purch-receipt-goods-item-list :receiptId="receiptId"></swb-purch-receipt-goods-item-list>' +
        '</div>',
        data: {
            receiptId: receiptId
        },
        okClicked: function () {
        },
        lifecycle: {
            created: function () {
            }
        }
    });
}

Vue.regist(SwbSettlePaymentInfo);
// 付款信息
export function showSettlePaymentInfoDlg(dlgConfig, callback) {
    let proofId = dlgConfig["proofId"];
    let parentPath = dlgConfig["parentPath"];
    let theDlg = Vue.$showDialog({
        title: '结算单 - 付款信息',
        width: -100,
        height: 900,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: false,
        cancelText: '关闭',
        template: '<swb-settle-payment-info :proofId="proofId" :parentPath="parentPath" ref="swb_settle_payment_info"></swb-settle-payment-info>',
        data: {
            proofId: proofId,
            parentPath: parentPath
        },
        okClicked: function () {
            return false;
        },
        cancelClicked: function () {
            let result = this.$refs.swb_settle_payment_info.getDlgResult() || {};
            if(result.type === 'info') {
                let refresh = result.data || false;
                callback(refresh);
            } else {
                MsgBox.warning(result.message);
            }
        }
    });
}

import SwbSettlePayItemList from './SettlePayItemList';
Vue.regist(SwbSettlePayItemList);
// 结算支付情况列表
export function openSettlePayItemListDlg(params) {
    //
    let title = params["title"] || '支付详情 - 查看';
    let filter = params["filter"] || {};
    let theDlg = Vue.$showDialog({
        title: title,
        width: 1200,
        height: 800,
        showCloseBtn: true,
        template: '<div class = "">' +
        '<swb-settle-pay-item-list :filter="filter" ref="swb_settle_pay_item_list"></swb-settle-pay-item-list>' +
        '</div>',
        data: {
            filter: filter
        },
        okClicked: function () {
        },
        lifecycle: {}
    });
}

Vue.regist(SwbPayPreInfo);
// 金额预付功能
export function showPayPreInfoDlg(dlgConfig, callback) {
    let title = dlgConfig["title"] || "金额 - 预付";
    let contractId = dlgConfig["contractId"];
    let contractNo = dlgConfig["contractNo"];
    let payPhaseTplId = dlgConfig["payPhaseTplId"];
    let orderType = dlgConfig["orderType"];
    let orderId = dlgConfig["orderId"];
    let orderNo = dlgConfig["orderNo"];
    let sellerRealComId = dlgConfig["sellerRealComId"];
    let buyerRealComId = dlgConfig["buyerRealComId"];
    let amount = dlgConfig["amount"];
    let theDlg = Vue.$showDialog({
        title: title,
        width: 650,
        height: 850,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-pay-pre-info :contractId="contractId" :contractNo="contractNo" :payPhaseTplId="payPhaseTplId" :orderType="orderType" :orderId="orderId" :orderNo="orderNo" :sellerRealComId="sellerRealComId" :buyerRealComId="buyerRealComId" :amount="amount" ref="swb_pay_pre_info"></swb-pay-pre-info>',
        data: {
            contractId: contractId,
            contractNo: contractNo,
            payPhaseTplId: payPhaseTplId,
            orderType: orderType,
            orderId: orderId,
            orderNo: orderNo,
            buyerRealComId: buyerRealComId,
            sellerRealComId: sellerRealComId,
            amount: amount
        },
        okClicked: function () {
            let result = this.$refs.swb_pay_pre_info.getDlgResult() || {};
            if(result.type === 'info') {
                let payPreInfo = result.data || {};
                callback(payPreInfo, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

Vue.regist(SwbPayVoucherSave);
// 金额支付功能
export function showPayVoucherSaveDlg(dlgConfig, callback) {
    let title = dlgConfig["title"] || "付款 - 申请";
    let availableAmount = dlgConfig["availableAmount"];
    let proofId = dlgConfig["proofId"];
    let contractId = dlgConfig["contractId"];
    let sellerRealComId = dlgConfig["sellerRealComId"];
    let buyerRealComId = dlgConfig["buyerRealComId"];
    let theDlg = Vue.$showDialog({
        title: title,
        width: 650,
        height: 850,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-pay-voucher-save :proofId="proofId" :contractId="contractId" :sellerRealComId="sellerRealComId" :buyerRealComId="buyerRealComId" :availableAmount="availableAmount" ref="swb_pay_voucher_save"></swb-pay-voucher-save>',
        data: {
            proofId: proofId,
            contractId: contractId,
            sellerRealComId: sellerRealComId,
            buyerRealComId: buyerRealComId,
            availableAmount: availableAmount
        },
        okClicked: function () {
            let result = this.$refs.swb_pay_voucher_save.getDlgResult() || {};
            if(result.type === 'info') {
                let payPreInfo = result.data || {};
                callback(payPreInfo, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

Vue.regist(SwbBankAccInfo);
// 补充银行卡信息
export function showBankAccInfoDlg(payVoucherInfo, callback) {
    let title = "银行卡信息 - 编辑";
    let theDlg = Vue.$showDialog({
        title: title,
        width: 650,
        height: 700,
        showCloseBtn: true,
        cancelVisible: true,
        okVisible: true,
        template: '<swb-bank-acc-info :payVoucherInfo="payVoucherInfo" ref="swb_bank_acc_info"></swb-bank-acc-info>',
        data: {
            payVoucherInfo: payVoucherInfo
        },
        okClicked: function () {
            let result = this.$refs.swb_bank_acc_info.getDlgResult() || {};
            if(result.type === 'info') {
                let bankAccInfo = result.data || {};
                callback(bankAccInfo, theDlg);
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/settle/showDlg.js
// module id = 191
// module chunks = 0